<!-- 
CustomerIdContent.vue
功能：客戶ID異動_ID異動內容
作者：i9400538 陳博承
完成：2021-09-23
-->
<template>
  <div class="container">
    <div class="row">
      <table class="table table-basic mt-4 mb-4">
        <thead>
          <tr>
            <th id="th_input_user" class="w-220">輸入人員</th>
            <td>
              <div class="col-12">{{ UserInfo.name }}</div>
            </td>
          </tr>
          <tr>
            <th id="th_form_id" class="w-220">簡覆表編號</th>
            <td>
              <div class="col-12">
                <input
                  type="text"
                  maxlength="20"
                  :id="`form_id-${colKey}`"
                  :data-vv-name="`form_id-${colKey}`"
                  placeholder="請輸入簡覆表編號"
                  v-validate="'required'"
                  data-vv-as="簡覆表編號"
                  class="form-control w-30"
                  v-model="form.form_id"
                  alt="ch"
                  :class="{ 'is-invalid': errors.has(`form_id-${colKey}`) }"
                />
              </div>
            </td>
          </tr>
          <tr>
            <th id="th_cust_new" class="w-220">新客戶ID</th>
            <td>
              <div class="col-12">
                <input
                  type="text"
                  maxlength="10"
                  :id="`cust_new-${colKey}`"
                  :data-vv-name="`cust_new-${colKey}`"
                  placeholder="請輸入新客戶ID"
                  v-validate="'required|checkCustomerId'"
                  data-vv-as="新客戶ID"
                  class="form-control w-30"
                  v-model="form.cust_new"
                  alt="ch"
                  :class="{ 'is-invalid': errors.has(`cust_new-${colKey}`) }"
                  style="display:inline-block"
                />
                &nbsp;&nbsp;
                <div class="checkbox checkbox-inline">
                  <input type="checkbox" v-model="form.isAG" id="chk-is-agent" />
                  <label for="chk-is-agent">是否為業務員</label>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th id="th_cust_old" class="w-220">原客戶ID</th>
            <td>
              <div class="col-12">
                <input
                  type="text"
                  maxlength="10"
                  :id="`cust_old-${colKey}`"
                  :data-vv-name="`cust_old-${colKey}`"
                  placeholder="請輸入原客戶ID"
                  v-validate="'required|checkCustomerId'"
                  data-vv-as="原客戶ID"
                  class="form-control w-30"
                  v-model="form.cust_old"
                  alt="ch"
                  :class="{ 'is-invalid': errors.has(`cust_old-${colKey}`) }"
                />
              </div>
            </td>
          </tr>
          <tr>
            <th id="th_form_agnt_id" class="w-220">業務員ID</th>
            <td>
              <div class="col-12">
                <input
                  type="text"
                  maxlength="10"
                  :id="`form_agnt_id-${colKey}`"
                  :data-vv-name="`form_agnt_id-${colKey}`"
                  placeholder="請輸入原業務員ID"
                  v-validate="'required|checkCustomerId'"
                  data-vv-as="業務員ID"
                  class="form-control w-30"
                  v-model="form.form_agnt_id"
                  alt="ch"
                  :class="{ 'is-invalid': errors.has(`form_agnt_id-${colKey}`) }"
                />
              </div>
            </td>
          </tr>
          <tr>
            <th id="th_today" class="w-220">異動日期</th>
            <td>
              <div class="col-12">{{today | dateFormat}}</div>
            </td>
          </tr>
        </thead>
      </table>
      <div class="col-12 text-red ml-3 mr-5">提醒：異動客戶ID適用於CRM、保單健檢、新建議書及BOX系統。</div>
      <div class="col-12 text-red ml-3 mr-5">提醒：異動業務員ID適用於CRM、保單健檢、新建議書及BOX系統。</div>
      <div class="col-12 text-red ml-3 mr-5">如異動後有失敗請通知IT單位</div>
      <div class="col-12">
        <div class="action text-right">
          <a class="btn btn-default" @click="doReset">重設</a>
          <a class="btn btn-primary" @click="doSubmit">確定</a>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="mxMaskContent" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { Validator } from "vee-validate";
//component
import mxMask from "@/desktop/components/mxMask";
//service
import { addCustomerIdData } from "@/service";
export default {
  name: "CustomerIdContent",
  mixins: [commonMixin],
  components: { mxMask },
  computed: {
    ...mapGetters(["UserInfo"])
  },
  data() {
    return {
      today: "",
      mxMaskOpen: false,
      mxMaskContent: "資料儲存中，請稍候...",
      form: {
        form_id: "", //簡覆表編號
        cust_new: "", //新客戶ID
        cust_old: "", //舊客戶ID
        form_agnt_id: "", //業務員ID
        isAG: false //是否為業務員
      },
      colKey: "1" //串欄位key用
    };
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //重設
    doReset() {
      this.form = {
        form_id: "", //簡覆表編號
        cust_new: "", //新客戶ID
        cust_old: "", //舊客戶ID
        form_agnt_id: "", //業務員ID
        isAG: false //是否為業務員
      };
      this.$validator.reset();
      this.$toast.info({ title: "畫面重設成功" });
    },
    doSubmit() {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        this.form.input_id = this.UserInfo.id;
        this.form.isAgent = this.form.isAG ? "Y" : "N";
        this.mxMaskOpen = true;
        //新增
        addCustomerIdData(this.UserInfo.id, this.form).then(result => {
          this.mxMaskOpen = false;
          if (result.header && result.header.status == "200") {     
            this.setToastMsg(result.header.message+" "+result.body.result_message);
            //新增成功, 導頁到查詢檢視頁面
            this.$router.push({
              name: "backend-tab5-2",
              params: {
                isFromAdd: true
              }
            });

          } else {
            let headerMessage = result.header.message
            if(headerMessage.includes('查無資料')){
              headerMessage  = '查無客戶資料' + headerMessage.split('查無資料')[1]
            }
            this.setToastMsg(headerMessage);
          }
        });
      });
    },
    //檢核規則初始化
    initValidator() {
      //檢查客戶ID是否滿10碼
      Validator.extend("checkCustomerId", {
        getMessage: "此ID格式有誤",
        validate: value => {
          return value.length == 10;
        }
      });
    }
  },
  mounted() {
    this.today = this.getCurrentDate(); //取得當天日期
    this.initValidator();
  }
};
</script>
<style>
.w-30 {
  width: 30% !important;
}
</style>